import axios from 'axios';

import { handleApiSucess, handleApiError, getRequestHeaders } from 'api/util.api';
import { handleRequest } from './util.api';

const getNotificationsHistoricUrl = (cId, sId) =>
  `/companies/${cId}/subcompanies/${sId}/notifications_historic`;

const getNotificationHistoricByIdUrl = (aId, cId, sId) =>
  `/companies/${cId}/subcompanies/${sId}/notifications_historic/${aId}`;

const addNotificationHistoricUrl = (cId, sId) =>
  `/companies/${cId}/subcompanies/${sId}/notifications_historic`;

const updateNotificationHistoricUrl = (aId, cId, sId) =>
  `/companies/${cId}/subcompanies/${sId}/notifications_historic/${aId}`;

const toggleNotificationHistoricUrl = (aId, cId, sId) =>
  `/companies/${cId}/subcompanies/${sId}/notifications_historic/${aId}/toggle`;

const formConfigUrl = (cId, sId) =>
  `/companies/${cId}/subcompanies/${sId}/notifications_historic/form_config`;

const service = {
  configure(endpoint = '', auth = {}, defaultHeaders = {}) {
    this.endpoint = endpoint;
    this.auth = auth;
    this.defaultHeaders = defaultHeaders;
    this.getHeaders = getRequestHeaders(this.auth, this.defaultHeaders);

    this.axios = axios.create({
      baseURL: this.endpoint,
      timeout: 30000,
    });

    this.axios.interceptors.request.use((request) => {
      handleRequest(request);
      return request;
    });

    return this;
  },

  get(companyId, subcompanyId, filters, limit, page, orderBy, order) {
    const url = getNotificationsHistoricUrl(companyId, subcompanyId);
    const params = { ...filters, limit, page, orderBy, order };
    return this.axios
      .get(url, { ...this.getHeaders(), params })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  getById(accountId, companyId, subcompanyId) {
    const url = getNotificationHistoricByIdUrl(accountId, companyId, subcompanyId);
    return this.axios
      .get(url, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  add(companyId, subcompanyId, account) {
    const url = addNotificationHistoricUrl(companyId, subcompanyId);

    account._customFields = account.customFields;
    account._financialDepreciation = account.financialDepreciation;
    account._fiscalDepreciation = account.fiscalDepreciation;
    delete account.customFields;
    delete account.financialDepreciation;
    delete account.fiscalDepreciation;

    return this.axios
      .post(url, account, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  update(accountId, companyId, subcompanyId, account) {
    const url = updateNotificationHistoricUrl(accountId, companyId, subcompanyId);

    account._customFields = account.customFields;
    account._financialDepreciation = account.financialDepreciation;
    account._fiscalDepreciation = account.fiscalDepreciation;

    delete account.customFields;
    delete account.financialDepreciation;
    delete account.fiscalDepreciation;

    return this.axios
      .put(url, account, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  toggle(accountId, companyId, subcompanyId) {
    const url = toggleNotificationHistoricUrl(accountId, companyId, subcompanyId);
    return this.axios
      .put(url, {}, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  formConfig(companyId, subcompanyId) {
    const url = formConfigUrl(companyId, subcompanyId);
    return this.axios
      .get(url, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },
};

export default service;



// WEBPACK FOOTER //
// src/lib/api/notifications_historic.api.js